import {err} from 'framework';
import type {Result, ValidationError} from 'framework';
import type {DashboardError} from '../../domain/errors';
import type {EditMealCommand} from '../../domain/edit-meal-command';
import type {MealDetail} from '../../domain/meal-detail';
import type {MealId} from '../../domain/meal-id.value-object';
import type {EditMealCommandValidator} from '../validators/edit-meal-command.validator';
import type {DashboardRepository} from '../ports/dashboard.repository';

export interface EditMealInput {
  readonly mealId: MealId;
  readonly command: EditMealCommand;
}

export class EditMeal {
  constructor(
    private readonly dashboardRepository: DashboardRepository,
    private readonly validator: EditMealCommandValidator,
  ) {}

  execute(input: EditMealInput): Promise<Result<MealDetail, DashboardError | ValidationError>> {
    const valid = this.validator.validate(input.command);

    if (!valid.ok) {
      return Promise.resolve(err(valid.error));
    }

    return this.dashboardRepository.editMeal({mealId: input.mealId, command: valid.data});
  }
}
